import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fiskal_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErr(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtIDR = (n) =>
  "Rp " + (Number(n || 0)).toLocaleString("id-ID", { maximumFractionDigits: 0 });

export const fmtNum = (n) => (Number(n || 0)).toLocaleString("id-ID", { maximumFractionDigits: 0 });
export { fmt2 } from "@/lib/num";

export const STATUS_LABELS = {
  draft: "Draft",
  review: "Review",
  checked: "Diperiksa",
  revisi: "Revisi",
  approved: "Approved",
  archived: "Archived",
};

export const STATUS_CLASSES = {
  draft: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/70 dark:text-amber-200 dark:border-amber-800",
  review: "bg-blue-100 text-blue-900 border-blue-300 dark:bg-blue-950/70 dark:text-blue-200 dark:border-blue-800",
  checked: "bg-indigo-100 text-indigo-900 border-indigo-300 dark:bg-indigo-950/70 dark:text-indigo-200 dark:border-indigo-800",
  revisi: "bg-rose-100 text-rose-900 border-rose-300 dark:bg-rose-950/70 dark:text-rose-200 dark:border-rose-800",
  approved: "bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-950/70 dark:text-emerald-200 dark:border-emerald-800",
  archived: "bg-slate-200 text-slate-800 border-slate-400 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
};

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  staff_keuangan: "Staff Keuangan",
  staff_pajak: "Staff Pajak",
  supervisor: "Supervisor",
  leader: "Leader",
  client_staff: "Client Staff",
  client_backup: "Client Backup",
};

export const isInternal = (role) =>
  ["super_admin", "staff_keuangan", "staff_pajak", "supervisor", "leader"].includes(role);

export default api;
